/**
 * Gemini credentials form — the flow's own cross-package write-intent
 * contract, and nothing else. The form's field is component-local
 * @state() on gemini-credentials-form.view.ts itself, so there is no
 * shared draft to declare here.
 *
 * `geminiSaveIntent$` is the one thing this file exists to carry: the
 * form's Save & verify action leaves this package through it, and
 * web/src/admin/settings/integrations/gemini/form.sync.ts is the
 * sole subscriber, forwarding straight into the EXISTING
 * saveIntegrationAction$ (web's integrations.state.ts) — this
 * package can never reach that subject itself, since it cannot import an
 * app-workspace file.
 *
 * `apiKey` is optional on this payload: the form omits the KEY entirely
 * when the operator leaves the field blank on a workspace that already
 * holds a stored key, which is the save contract's own "keep whatever is
 * stored" signal (SaveIntegrationInput's gemini variant is `.nullish()`,
 * while REGISTRY's own field is `.min(1)` — so `""` is rejected, only
 * absence means keep).
 */
import { Subject } from "rxjs";

export const geminiSaveIntent$ = new Subject<{
	/** The organization the form opened under; a save after a switch names
	 *  it, so it lands there or nowhere. */
	readonly orgId: string | null;
	readonly apiKey?: string;
}>();
